<template>
  <div>
    <!-- Page withou access -->
    <h1>{{ $t("general.calendar.socialManagment") }}</h1>
    <div class="block-list">
      <p class="subtitle">{{ $t("general.calendar.planningSubtitle")}}</p>
      <div class="separator"></div>
      <ul class="list-items-offer">
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan1") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan2") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan3") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan4") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan5") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan6") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan7") }}</li>
        <li class="style-li"><i class="el-icon-circle-check"></i> {{ $t("general.calendar.slogan8") }}</li>
      </ul>
    </div>
    <div class="text-center box-icons">
      <el-row>
        <el-col :span="6" class="icons-facebook"><img src="../../../assets/facebook-logo-5-1.png"/></el-col>
        <el-col :span="6" class="icons-linkedin"><img src="../../../assets/linkedin-logo.png"/></el-col>
        <el-col :span="6" class="icons-google"><img src="../../../assets/1200px-Google-My-Business_logo.svg.png"/></el-col>
        <el-col :span="6" class="icons-instagram"><img src="../../../assets/2048px-Instagram_icon.png"/></el-col>
      </el-row>
    </div>
    <div class="text-center btn-com">
      <el-row>
        <el-button v-if="!isSubUser" @click="send">{{ $t("planning.beContacted") }}</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { sendEmail } from '@/services/email'

export default {
  name: 'TeasingCalendar',
  props: ['isSubUser'],
  data () {
    return {
      sendTo: null
    }
  },
  computed: {
    user () {
      return this.$store.state.app.user
    },
    sitimmoUser () {
      return this.$store.state.app.sitimmoUser
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('sfc', 'clic', category, this.sitimmoUser.id)
    },
    async send () {
      this.$ga.event('sfc', 'clic', 'etre_recontacte', this.sitimmoUser.id)
      const logo = processEnvConfig.VUE_APP_IMAGE_FILIGRANE_MAIL
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      this.loading = true
      const mailData = {
        to: this.sendTo,
        subject: this.$t('general.calendar.mailSubjectSocialManagmentPlus', { advertiser: this.user.advertiser }),
        content: '<div style="width: 700px; margin: auto;"> <div style="background-color: #255662; height: 140px; width: 700px; margin-bottom: 50px"> <img style="width: 350px; margin-top: 6%; margin-left: 29%" src="' + logo + '"> </div> <p style="font-family: Dosis, Arial, Helvetica, sans-serif; font-size: large;text-align: center;">' + this.$t('general.calendar.emailContentSocialManagmentPlus', { advertiser: this.user.advertiser, companyName: this.$store.state.app.sitimmoUser.nom, email: this.$store.state.app.sitimmoUser.email, phoneNumber: this.$store.state.app.sitimmoUser.telephone }) + '</p></div>'
      }
      try {
        const response = await sendEmail(mailData)
        this.$message({ message: this.$t('general.calendar.emailSendSuccess'), type: response.type })
      } catch (error) {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
      window.alert(this.$t('planning.dialogMessage'))
      this.loading = false
    }
  }
}
</script>

<style scoped>
.block-list {
  margin-bottom: 55px;
}

.style-li:first-child {
  margin-top: 35px;
}

.style-li {
  margin-bottom: 25px;
  font-size: 18px;
}

i {
 color: green;
}

.separator{
  width: 50%;
    background-color: #66BCC8 ;
    height: 1px;
    margin: 0 auto;
}

.subtitle {
    margin-left: 2%;
    margin-right: 5%;
    font-size: 180%;
    text-align: center;
}

.list-items-offer{
    margin-left: 5%;
    margin-right: 5%;
    font-size: 130%;
    list-style-type: none;
}

.list-items-offer li {
    text-align: center;
}

.box-icons {
  margin-bottom: 30px;
}

.icons-facebook img {
  width: 80px;
}
.icons-linkedin img {
    width: 70px;
}
.icons-google img {
    width: 80px;
}
.icons-instagram img {
    width: 75px;
}
</style>
